// Fixed order for the live-radio quick-launch (design review 2026-09-10). The
// channels store is sorted by title (app-initializer), so the menu re-sorts by this —
// and lists only these: `test` is a dev-only fifth station.
export const STATION_ORDER: readonly string[] = ['frisky', 'deep', 'chill', 'classics']

// Playback statuses (player-service.js) that mean a stream is live or on its way.
export const STREAMING_STATUSES: readonly string[] = ['playing', 'loading']
